import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import styled from 'styled-components';

import { useTranslation } from '../../../i18n';

import { getProviderConfig, ProviderInfo } from '../../../config/providers';

import { getInboundCountry } from '../../../entities/providers/selectors';

import { Card } from '../../element';
import { Image } from '../../image';

const ImageContainer = styled.div`
  margin: 18px 0;

  padding: 0 10%;
`;

const TextWrapper = styled.div`
  font-size: 12px;
  text-align: justify;
`;

export interface ProviderCardProps {
  className?: string;
}

export const ProviderCard: React.FC<ProviderCardProps> = (props) => {
  const [t] = useTranslation('rates');

  const { provider } = useSelector(getInboundCountry);

  const providerInfo = useMemo(() => {
    const { info = null } = getProviderConfig(provider);

    return info || ({} as ProviderInfo);
  }, [provider]);

  return (
    <Card {...props}>
      <ImageContainer>
        <Image src={providerInfo.logo} />
      </ImageContainer>
      <TextWrapper>{t(providerInfo.description)}</TextWrapper>
    </Card>
  );
};
